<script>

import {mapActions} from "pinia";
import {baseLoaderStore} from "@/store/baseLoaderStore";

export default {
  name: "OrgProfileManageAdmins",
  props: {
    orgId: {
      type: Number
    }
  },
  computed: {
    frameUrl() {
      return `/orgdesktop/${this.orgId}/manageadmins?_f=true&showAsPage=false`;
    }
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'hideBaseLoader'
    ]),
  },
  mounted() {
    document.getElementById('manageAdminsViewFrame').onload = () => {
      this.hideBaseLoader();
    };
  }
}

</script>

<template>
  <div>
    <iframe :src="frameUrl" frameborder="0" id="manageAdminsViewFrame" class="manage-admins-view-frame"></iframe>
  </div>
</template>

<style scoped lang="scss">
.manage-admins-view-frame {
  width: 100%;
  height: 1240px;
}
</style>